import React from 'react';

export function EvalBar({ evalInfo, material, theme }) {
  const height = 560; // match board
  const width = 16;
  const info = evalInfo || { percent: 0.5, label: '' };
  const pct = Math.max(0, Math.min(1, info.percent == null ? 0.5 : info.percent));
  const whiteHeight = Math.round(height * pct);
  const blackHeight = height - whiteHeight;
  const label = info.label || '';

  // Positional overlay between material-only boundary and eval boundary
  let deltaTop = null;
  let deltaHeight = null;
  let advantagedIsWhite = pct >= 0.5;
  let positionalCp = null;
  let materialCp = null;

  try {
    const mat = material || { white: 0, black: 0 };
    materialCp = ((mat.white || 0) - (mat.black || 0)) * 100;
    const materialScaled = Math.tanh(materialCp / 400);
    const pctMat = (materialScaled + 1) / 2;
    const boundaryEvalTop = Math.round(height * (1 - pct));
    const boundaryMatTop = Math.round(height * (1 - pctMat));
    const top = Math.min(boundaryEvalTop, boundaryMatTop);
    const h = Math.abs(boundaryEvalTop - boundaryMatTop);
    if (h > 0) {
      deltaTop = top;
      deltaHeight = Math.max(1, h);
      if (typeof info.whiteCp === 'number') {
        positionalCp = info.whiteCp - materialCp;
        advantagedIsWhite = positionalCp >= 0;
      }
    }
  } catch (_) {}

  // Build stripe overlay and positional label
  const stripeA = advantagedIsWhite ? '#ffffff' : '#000000';
  const stripeB = advantagedIsWhite ? 'rgba(220,220,220,0.9)' : 'rgba(90,90,90,0.9)';
  const overlayStyle = deltaTop != null ? {
    position: 'absolute', top: deltaTop, left: 0, right: 0, height: deltaHeight,
    background: `repeating-linear-gradient(45deg, ${stripeA} 0 6px, ${stripeB} 6px 12px)`
  } : null;

  // Build positional label text
  const mStr = (typeof materialCp === 'number') ? `${materialCp >= 0 ? '+' : ''}${(materialCp / 100).toFixed(2)}` : null;
  const pStr = (typeof positionalCp === 'number') ? `${positionalCp >= 0 ? '+' : ''}${(positionalCp / 100).toFixed(2)}` : null;
  const mainLabel = label || '0.00';
  const deemph = theme === 'dark' ? '#bbb' : '#666';

  return (
    <div style={{ display: 'flex', alignItems: 'stretch', gap: 8 }}>
      <div style={{ position: 'relative', width, height, border: '1px solid #555', borderRadius: 4, overflow: 'hidden' }} title={label ? `Eval ${label}` : 'Evaluating...'}>
        <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, height: whiteHeight, background: '#ffffff' }} />
        <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: blackHeight, background: '#000000' }} />
        {/* Optional mid-line */}
        <div style={{ position: 'absolute', top: height/2 - 0.5, left: 0, right: 0, height: 1, background: 'rgba(127,127,127,0.4)' }} />
        {overlayStyle ? (<div style={overlayStyle} />) : null}
      </div>
      <div style={{ width: 160, textAlign: 'left', fontVariantNumeric: 'tabular-nums', display: 'flex', flexDirection: 'column', justifyContent: 'center', height }}>
        <div style={{ fontSize: 14, fontWeight: 700 }}>{mainLabel}</div>
        {(mStr != null || pStr != null) ? (
          <div style={{ marginTop: 2, fontSize: 12, color: deemph, lineHeight: '14px' }}>
            {mStr != null ? (<div>Material: {mStr}</div>) : null}
            {pStr != null ? (<div>Positional: {pStr}</div>) : null}
          </div>
        ) : null}
      </div>
    </div>
  );
}

